module.exports = {
  src: __webpack_public_path__ + "static/media/AlanHoney.29a7a2e8.jpg",
  width: 480,
  height: 600,
  bytes: 139272,
  type: "jpg",
};
module.exports.toString = function() {
  return __webpack_public_path__ + "static/media/AlanHoney.29a7a2e8.jpg";
};


//////////////////
// WEBPACK FOOTER
// ./src/core/images/AlanHoney.jpg
// module id = 50
// module chunks = 0